import React, { useContext, useEffect, useState } from 'react';
import StylesContext from '../context/StylesContext';
import api from '../api';
import { useParams } from 'react-router-dom';
import MainContainer, { GlobalStyles } from '../components/MainContainer';
import CategoriesCard from '../components/CategoriesCard';
import StyledContainer from '../components/StyledContainer';
import MenuIcon from '../components/MenuIcon';
import '../styles/CategoryList.css';
import MainLogoContainer from '../components/MainLogoContainer';
import StyledTitle from '../components/StyledTitle';
import TopText from '../components/TopText';
import categoriesProps from '../interfaces/CategoryProps';
import Footer from '../components/Footer';
import useSessionStorage from '../hooks/useSessionStorage';
import { useLanguage } from "../hooks/languageService";
import { categoryItemsPath, subcategoriesPath, hasSubcategories } from '../helpers/menuRoutes';


const MenuTranslate = {
  'pt-BR': 'CARDÁPIO',
  'en-US' : 'MENU',
  'es-ES' : 'MENÚ'
}

const CategoriesList = () => {
  const { styles, setStyles } = useContext(StylesContext);
      const [ categories, setCategories ] = useState<Array<categoriesProps>>();
      const { getStylesFromSessionStorage } = useSessionStorage();
      
      const { menu } = useParams<{menu: string}>();
      const { selectedLanguage } = useLanguage();
    const langId = selectedLanguage.split("-")[0];
    const langEndpoint = langId.includes("pt") ? "" : `-${langId}`;

  useEffect(() => {
    const getStyles = async () => {
      try {
        const stylesSessionStorage = getStylesFromSessionStorage();
        if (stylesSessionStorage) {
          setStyles(stylesSessionStorage);          
        } else {
          const { data } = await api.get(`menu_styles/${menu}`);
          setStyles(data);
        };
      } catch(error: any) {
      console.error(error.message);
      };
    };    
    getStyles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menu]);

  useEffect(() => {
    const getCategories = async () => {
      try {
        const { data } = await api.get(
          `categories/?url_id=${menu}${langEndpoint}`
        );
        
        setCategories(data);
      } catch (error: any) {
        console.error(error.message);
      }
    };
    ///${menu}${langEndpoint}`
    getCategories();
  }, [menu]);  

  return (
    <MainContainer $backgroundColor={styles.bgColor} className='categories_list_page'>
      <GlobalStyles $backgroundColor={styles?.bgColor}/>
        <>
          <StyledContainer className='logo_client_categories_wrapper' /* onClick={handleClick} */>
            <TopText />
          <MainLogoContainer wrapperClass='logo_client_categories' />
          </StyledContainer>
          <StyledContainer className='container_title_icon'>
            <StyledContainer className='menu_icon_wrapper'>
              <MenuIcon color={styles.menuIconColor} />
            </StyledContainer>
            <StyledTitle
              className='title_categories_list'
              $textColor={styles.textColor}
              >
          { MenuTranslate[selectedLanguage as keyof typeof MenuTranslate]}
            </StyledTitle>
          </StyledContainer>
          <StyledContainer className='categories_card_container'>
            {
              categories?.map(categorieEl => (
                <CategoriesCard
                isButton={true}
                key={categorieEl.id ?? categorieEl.category_name}
                categorieElement={categorieEl.category_name}
                categorieImage={categorieEl.category_image}
                to={
                  // categoria com subcategorias abre a tela intermediária;
                  // sem subcategorias segue direto para os itens, como antes
                  hasSubcategories(categorieEl)
                    ? subcategoriesPath(menu, categorieEl.category_name)
                    : categoryItemsPath(menu, categorieEl.category_name)
                }
                />
              ))
            }
          </StyledContainer>
          </>
      <Footer $footerLogoColor={ styles.footerColor } classCategories='footer-categories' />
    </MainContainer>
  );
};

export default CategoriesList;
